import { render, staticRenderFns } from "./renovacao.vue?vue&type=template&id=588ea715"
import script from "./renovacao.vue?vue&type=script&lang=js"
export * from "./renovacao.vue?vue&type=script&lang=js"
import style0 from "./renovacao.vue?vue&type=style&index=0&id=588ea715&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports